module.exports = __webpack_public_path__ + "img/electric_reserved.063dd323.svg";